module.exports = __webpack_public_path__ + "static/img/logodefault.3300741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logodefault.png
// module id = lm2D
// module chunks = 1